import {guardedFetcher} from 'src/utils/guardedFetcher';

const prefix = 'backup/info/all-tables';

export const BackupControlServices = {
  get: () => guardedFetcher.get(prefix),
};
